var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"screenBtn"},[_c('img',{attrs:{"src":require("@/assets/images/screen.png"),"alt":""}}),_c('div',{staticClass:"screenInfo",on:{"click":_vm.screenHot}},[_vm._v("截图至云端")])])}
var staticRenderFns = []

export { render, staticRenderFns }